import { AdboxDto } from '@nccore/shared';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { setApiHeaders } from '../../api';
import { environment } from '../../environments/environment';
import { AdboxModel } from '../../models';

// Define a service using a base URL and expected endpoints
export const adboxApi = createApi({
  reducerPath: 'adboxApi',
  baseQuery: fetchBaseQuery({
    baseUrl: environment.apiHost + '/adbox',
    prepareHeaders: setApiHeaders,
  }),
  endpoints: (builder) => ({
    getAdbox: builder.query<AdboxModel, string>({
      query: (uuid) => ({ url: uuid }),
      keepUnusedDataFor: 0,
    }),
    createAdbox: builder.query<AdboxModel, AdboxDto>({
      query: (dto) => ({ method: 'POST', url: '', body: dto }),
    }),
    updateAdbox: builder.query<AdboxModel, { uuid: string; dto: AdboxDto }>({
      query: ({ uuid, dto }) => ({ method: 'PUT', url: uuid, body: dto }),
    }),
    deleteAdbox: builder.query<AdboxModel, string>({
      query: (uuid) => ({ method: 'DELETE', url: uuid }),
    }),
  }),
});

export const { useGetAdboxQuery, useLazyCreateAdboxQuery, useLazyUpdateAdboxQuery, useLazyDeleteAdboxQuery } = adboxApi;
